import {
  GET_SHOWROOMS,
  GET_SHOWROOMS_SUCCESS,
  GET_SHOWROOMS_FAIL,
  GET_SHOWROOM_DETAILS,
  GET_SHOWROOM_DETAILS_SUCCESS,
  GET_SHOWROOM_DETAILS_FAIL,
  CREATE_SHOWROOM,
  CREATE_SHOWROOM_SUCCESS,
  CREATE_SHOWROOM_FAIL,
  UPDATE_SHOWROOM,
  UPDATE_SHOWROOM_SUCCESS,
  UPDATE_SHOWROOM_FAIL,
  DELETE_SHOWROOM,
  DELETE_SHOWROOM_SUCCESS,
  DELETE_SHOWROOM_FAIL,
 
} from "./actionTypes"

const INIT_STATE = {

  showrooms: {
    showrooms: [],
    total: "",
    page: "",
  },
  showroomDetails: {},
  error: {},
  loading: false,
}

const Showroom = (state = INIT_STATE, action) => {
  switch (action.type) {
    // Showroom - This line cannot be edited or removed
    case GET_SHOWROOMS:
    case GET_SHOWROOM_DETAILS:
    case CREATE_SHOWROOM:
    case UPDATE_SHOWROOM:
    case DELETE_SHOWROOM:
      return {
        ...state,
        loading: true,
      }

    case DELETE_SHOWROOM_FAIL:
    case GET_SHOWROOMS_FAIL:
    case GET_SHOWROOM_DETAILS_FAIL:
    case UPDATE_SHOWROOM_FAIL:
    case CREATE_SHOWROOM_FAIL:
      return {
        ...state,
        error: action.payload,
        loading: false,
      }

    case GET_SHOWROOMS_SUCCESS:
      return {
        ...state,
        showrooms: action.payload,
        error: {},
        loading: false,
      }

    case GET_SHOWROOM_DETAILS_SUCCESS:
      return {
        ...state,
        showroomDetails: action.payload,
        error: {},
        loading: false,
      }

    case CREATE_SHOWROOM_SUCCESS:
      return {
        ...state,
        showrooms: {
          ...state.showrooms,
          showrooms: [action.payload, ...state.showrooms.showrooms],
          total: state.showrooms.total + 1,
        },
        showroomDetails: action.payload,
        error: {},
        loading: false,
      }

    case UPDATE_SHOWROOM_SUCCESS:
      return {
        ...state,
        showrooms: {
          ...state.showrooms,
          showrooms: state.showrooms.showrooms.map(client =>
            client._id === action.payload._id
              ? { ...client, ...action.payload }
              : client
          ),
        },
        showroomDetails: action.payload,
        loading: false,
        error: {},
      }

    case DELETE_SHOWROOM_SUCCESS:
      return {
        ...state,
        showrooms: {
          ...state.showrooms,
          showrooms: state.showrooms.showrooms.filter(
            client => client._id !== action.payload._id
          ),
        },
        error: {},
        loading: false,
      }

    default:
      return state
  }
}

export default Showroom
